export default "__VITE_ASSET__CN8DUlRf__"